module.exports = __webpack_public_path__ + "static/media/layer2M.d9640ab7.png";